const removeReport = require('./report/api/remove')

module.exports = async (state, id) => {
  return removeReport(state, {reportId: id})
}
